/**
 * Customization: Simple wishlist icon component for APC header and mobile menu.
 * Toggles filled/empty heart icon based on wishlist count.
 * Listens for apa:wishlist:count events dispatched by the wishlist system.
 */
class ApcWishlistIcon extends HTMLElement {
  #HAS_ITEMS_CLASS = 'header-actions__wishlist-icon--has-items';

  connectedCallback() {
    const count = window.apa?.wishlist?.count ?? 0;
    this.classList.toggle(this.#HAS_ITEMS_CLASS, count > 0);

    document.addEventListener('apa:wishlist:count', this.#onCountUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('apa:wishlist:count', this.#onCountUpdate);
  }

  #onCountUpdate = (event) => {
    const count = event.detail?.count ?? 0;
    this.classList.toggle(this.#HAS_ITEMS_CLASS, count > 0);
  };
}

if (!customElements.get('apc-wishlist-icon')) {
  customElements.define('apc-wishlist-icon', ApcWishlistIcon);
}
